module.exports = __webpack_public_path__ + "img/rancher-logo.1d5c3581.svg";